export default __webpack_public_path__ + "static/media/audio.f5c472c6.mp3";